// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___z5tbq","container":"styles__container___3ah-2","arrow":"styles__arrow___2y-Ns","menu":"styles__menu___1RpAA","menuOpen":"styles__menuOpen___3orHv","item":"styles__item___2n1lj","itemSelected":"styles__itemSelected___8mYad","checkIcon":"styles__checkIcon___30-ao","badgeContainer":"styles__badgeContainer___2JfTD","badge":"styles__badge___1u7N_","removeBtn":"styles__removeBtn___1FA44"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/ConsumptionProfile/components/SelectPeriod/styles.css
// module id = 2919
// module chunks = 0